var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.157,
    height: 16.618,
    viewBox: "0 0 16.157 16.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "restore",
    transform: "translate(-7.11 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64010",
    "data-name": "Path 64010",
    d: "M80.97,84.859a.569.569,0,0,1-.542.4.563.563,0,0,1-.17-.026l-.434-.136a5.786,5.786,0,1,0,1.152-.556A.564.564,0,0,1,80.97,84.859Zm.569,1.824a.568.568,0,0,1,1.137,0v3.093a.463.463,0,0,0,.463.463H85.2a.568.568,0,1,1,0,1.137H83.138a1.6,1.6,0,0,1-1.6-1.6Z",
    transform: "translate(-67.718 -81.473)",
    fill: "#1a49a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64011",
    "data-name": "Path 64011",
    d: "M20.9,2.832a8.085,8.085,0,0,0-9.1-1.624L11.971.78A.568.568,0,1,0,10.912.366l-.7,1.793A.778.778,0,0,0,10.7,3.183l1.4.44a5.792,5.792,0,0,1,1.152-.556.568.568,0,0,0-.377-.392l-.907-.284a6.936,6.936,0,1,1-2.981,3.02A.568.568,0,1,0,7.979,4.9,8.079,8.079,0,1,0,20.9,2.832Z",
    transform: "translate(0 0)",
    fill: "#1a49a3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.31b9dbd3c58dbc6fd7484e05a00b0542.svg";
export { ForwardRef as ReactComponent };